/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IBillingInputUpgradeToProfessional,
  IBillingInputUpdateSeats,
} from '../types/request.types'
import {
  IBillingOutputBillingChangeResult,
} from '../types/response.types'

export default new class BillingAPI extends RequestHandler {
  /****** POST methods *****/
  public async post_UpgradeToProfessional(
    data: IBillingInputUpgradeToProfessional,
  ): Promise<IBillingOutputBillingChangeResult> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/billing/upgrade-to-professional`,
      data,
    })
  }
  public async post_UpdateSeats(
    data: IBillingInputUpdateSeats,
  ): Promise<IBillingOutputBillingChangeResult> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/billing/seats`,
      data,
    })
  }
}()
